// extracted by css-extract-rspack-plugin
export default {"Container":"UpdatedBy-module__Container__wmAzHNj","UserLink":"UpdatedBy-module__UserLink__wlZpY8o","GitHubAvatar":"UpdatedBy-module__GitHubAvatar__vlAJnqG"};